// src/components/course_resources/CourseResourcesAdminContainer.jsx
import { connect } from "react-redux";
import CourseResourcesAdmin from "./CourseResourcesAdmin";
import {
  fetchCourseResources,
  createCourseResource,
  updateCourseResource,
  deleteCourseResource,
} from "../../actions/course_resources_actions";

const mapStateToProps = (state, ownProps) => {
  const slice = state.courseResources || {};
  const byId = slice.byId || {};
  const all = (slice.allIds || []).map((id) => byId[id]).filter(Boolean);

  return {
    courseKey: ownProps.courseKey,
    resources: all,
    isLoading: !!slice.isLoading,
    error: slice.error || "",
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchCourseResources: (params) => dispatch(fetchCourseResources(params)),
  createCourseResource: (formData) => dispatch(createCourseResource(formData)),
  updateCourseResource: (id, formData) => dispatch(updateCourseResource(id, formData)),
  deleteCourseResource: (id) => dispatch(deleteCourseResource(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CourseResourcesAdmin);
